import React from 'react';
import { FILTER_CHANGE_ANALYTICS } from '@atlassian/jira-admin-screens-services/src/common/constants';
import FilterSearch from '@atlassian/jira-common-components-filter-search/src/main.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { useAnalyticsEvents, fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { ISSUE_TYPE_SCREEN_SCHEME_NAME } from '../../constants';
import messages from './messages';

type Props = {
	searchFilter?: string;
	onFilterChange: (searchFilter: string) => void;
};
export default function IssueTypeScreenSchemeSearchBox({ onFilterChange, searchFilter }: Props) {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const analyticsEvent = createAnalyticsEvent({
		action: FILTER_CHANGE_ANALYTICS.ACTION,
		actionSubject: FILTER_CHANGE_ANALYTICS.ACTION_SUBJECT,
	});
	const { formatMessage } = useIntl();
	return (
		<FilterSearch
			placeholder={formatMessage(messages.placeholder)}
			increasedWidth
			value={searchFilter}
			placeholderAlwaysVisible
			isAlwaysExpanded
			onChange={(value: string) => {
				fireUIAnalytics(analyticsEvent, ISSUE_TYPE_SCREEN_SCHEME_NAME);
				onFilterChange(value);
			}}
		/>
	);
}
